<template>
  <div v-if="logo && profileStatus !== 'agent'" class="sidebar-logo-container">
    <div
      v-if="isLoaded"
      class="sidebar-logo sidebar-logo-auto-height my-3 pt-2"
    >
      <img
        :width="isMiniSidebar ? '60px' : '160px'"
        :src="logo.link"
        alt="Homewayz"
        @click.stop="imageClicked"
      >
    </div>
    <img v-show="false" :src="logo.link" @load="isLoaded = true">
  </div>
  <div v-else-if="isReady" class="sidebar-logo">
    <img
      :width="isMiniSidebar ? '24px' : '0px'"
      :class="{ 'opacity-zero': !isMiniSidebar, 'opacity-one': isMiniSidebar }"
      src="/img/homewayz-icon-gold-95w.svg"
      alt="Homewayz"
      @click.stop="imageClicked"
    >
    <img
      :width="isMiniSidebar ? '0px' : '160px'"
      :class="{ 'opacity-zero': isMiniSidebar, 'opacity-one': !isMiniSidebar }"
      src="/img/homewayz_logo_stacked.svg"
      alt="Homewayz"
      @click.stop="imageClicked"
    >
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  props: {
    isMiniSidebar: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoaded: false
    }
  },
  computed: {
    ...mapState('client', ['associatedAgent', 'associatedAgentDataReady']),
    ...mapState('common', ['profileStatus']),
    ...mapGetters('agent', ['getAgentLogo']),
    ...mapGetters('client', ['getAssociatedLogo']),
    logo() {
      if (this.getAgentLogo) {
        return this.getAgentLogo
      }
      if (this.getAssociatedLogo) {
        return this.getAssociatedLogo
      }
      return undefined
    },
    isReady() {
      if (this.profileStatus === 'client') {
        return this.associatedAgentDataReady
      }
      if (this.getAgentLogo) {
        return true
      }
      return true
    }
  },
  methods: {
    imageClicked() {
      this.$emit('image-clicked')
    }
  }
}
</script>

<style lang="sass" scoped>
.sidebar-logo-container
  min-height: 10rem
  display: flex
  align-items: center
  justify-content: center
.sidebar-logo
  display: flex
  justify-content: center
  height: 10rem
  &.sidebar-logo-auto-height
    height: auto
</style>
